// extracted by mini-css-extract-plugin
export var cancelButton = "_pp-5";
export var content = "_pp-3";
export var createButton = "_pp-6";
export var drawerContainer = "_pp-0";
export var footer = "_pp-2";
export var header = "_pp-1";
export var orderFormColumn = "_pp-4";